import { render, staticRenderFns } from "./public-document.vue?vue&type=template&id=25f5b2ea&scoped=true&"
import script from "./public-document.vue?vue&type=script&lang=js&"
export * from "./public-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5b2ea",
  null
  
)

export default component.exports